import React, { FC, useState } from "react";
import Popup from "../../Popup/Popup";
import { HorizontalStack, VerticalStack } from "../../Stack";
import { Stack, Text } from "@fluentui/react";
import { DocumentVersionInCard } from "../../Cards/DocumentVersionInCard";
import { useAppDispatch } from "../../../hooks/hooks";
import Loader from "../../Loader";
import { deleteVersion } from "../../../modules/redux/Documents/document";
import { t } from "i18next";
import { getSplitDocumentName } from "../../../utils";
import ErrorIcon from "../../../assets/Icons/svg/errorIcon";
import SuccessIcon from "../../../assets/Icons/svg/successIcon";

const DeleteVersionModal: FC<any> = (props) => {
  const dispatch = useAppDispatch();
  const [modal, setModal] = useState<boolean>(false);
  const [upload, setUpload] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const handleDeleteClick = () => {
    if (props.version) {
      setModal(true);
      dispatch(deleteVersion(props.version.id)).then((res: any) => {
        setUpload(true);
        if (res.meta.requestStatus === "fulfilled") {
          setMessage("Success");
          setTimeout(() => {
            props.refresh?.();
            props.hideModal();
          }, 2000);
        } else {
          setMessage("Error");
        }
        setTimeout(() => {
          disable();
        }, 3000);
      });
    }
  };

  function disable() {
    setUpload(false);
    setMessage("");
    setModal(false);
    props.hideModal();
  }
  const getTitleBackground = () => {
    if (!modal) return "#FCF0ED";
    if (upload && message === "Success") return "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)";
    if (upload && message === "Error") return "#FCF0ED";
    return "#FCF0ED";
  };

  const customContent = (
    <VerticalStack
      className="deleteVersionContainer"
      style={{ minHeight: !modal ? "490px" : "100px" }}
    >
      {modal ? (
        <VerticalStack
          style={{
            alignItems: upload ? "" : "center",
            justifyContent: upload ? "" : "space-between",
            backgroundColor: "",
            gap: "20px",
            padding: "20px 25px",
            width: "100%",
          }}
        >
          {!upload ? <Loader /> : null}
          <Text
            style={{
              fontSize: "17px",
            }}
            className="deleteContentText"
          >
            {upload ? (
              <Text className="deleteContentText">
                {`${getSplitDocumentName(props.version?.rootDocumentName)} V${
                  props.version.documentVersion
                }`}{" "}
                {t("deleted")}
              </Text>
            ) : (
              <Text className="deleteContentText">
                {t("deleting")}{" "}
                {`${getSplitDocumentName(props.version?.rootDocumentName)} V${
                  props.version.documentVersion
                }`}
              </Text>
            )}
          </Text>
        </VerticalStack>
      ) : (
        <>
          <VerticalStack
            style={{
              padding: "20px 25px 10px 20px",
            }}
          >
            <Text className="deleteContentText">
              {t("delete_v_conf")}&nbsp;V
              {props.version?.version}&nbsp;{t("delete_v_conf1")}
              &nbsp;
              {getSplitDocumentName(props.version?.rootDocumentName) ?? ""}&nbsp;?
            </Text>
          </VerticalStack>
          <Stack onClick={() => {}} style={{ paddingBottom: "20px" }}>
            <DocumentVersionInCard version={props.version} delete={true} />
          </Stack>
          <Stack className="horizontalLine"></Stack>
          <HorizontalStack
            className="deleteBottom"
            style={{ padding: "20px 25px" }}
          >
            <Text className="deleteCancelButton" onClick={props.hideModal}>
              {t("cancel")}
            </Text>
            <Text className="deleteButton" onClick={handleDeleteClick}>
              {t("delete")}
            </Text>
          </HorizontalStack>
        </>
      )}
    </VerticalStack>
  );

  return (
    <Popup
      isOpen={props.isModalOpen}
      title={
        upload
          ? message === "Success"
            ? t("success")
            : t("error")
          : t("delete_version")
      }
      iconName={upload ? <SuccessIcon /> : <ErrorIcon />} 
      contentTitle={upload ? t("success") : t("error")}
      content={upload ? t("success") : t("error")}
      onClose={modal ? disable : props.hideModal}
      customContent={customContent}
      showCloseButton={!modal}
      width="480px"
      minHeight={modal ? "100px" : "490px"}
      backgroundColor={
        upload && message === "Success"
          ? "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)"
          : "#FCF0ED"
      }
    />
  );
};

export default DeleteVersionModal;
